import { render, staticRenderFns } from "./JoinProfit.vue?vue&type=template&id=2d73b3ee&scoped=true&"
import script from "./JoinProfit.vue?vue&type=script&lang=js&"
export * from "./JoinProfit.vue?vue&type=script&lang=js&"
import style0 from "styles/views/join/joinprofit.css?vue&type=style&index=0&id=2d73b3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73b3ee",
  null
  
)

export default component.exports